// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1nTC9","topBottomGutter":"Layout_topBottomGutter__28bM1"};